import { closeAccordion } from "../../ui/accordion/index.js";
import { ProductCardCounter } from "./product-card-counter.js";
import { initProductTitle } from "./clamp-title.js";
import clamp from "clamp-js";

export function initProductCards() {
    const container = document; // Можно указать конкретный контейнер, если есть

    let lastShowedMore = null;

    function handleShowMore(productCardEl) {
        const showMoreAccordion = productCardEl.querySelector(".product-card__content-collapsed-buttons");
        const isOpening = showMoreAccordion.classList.contains("accordion--open");

        if (!lastShowedMore && isOpening) {
            productCardEl.classList.add("product-card--showed-more");
            lastShowedMore = productCardEl;
        } else if (isOpening) {
            productCardEl.classList.add("product-card--showed-more");

            const lastShowedMoreAccordion = lastShowedMore.querySelector(".product-card__content-collapsed-buttons");

            closeAccordion(lastShowedMoreAccordion, true, () => {
                lastShowedMore.classList.remove("product-card--showed-more");
                lastShowedMore = productCardEl;
            });
        } else {
            const productCardElAccordion = productCardEl.querySelector(".product-card__content-collapsed-buttons");

            closeAccordion(productCardElAccordion, true, () => {
                productCardEl.classList.remove("product-card--showed-more");
                lastShowedMore = null;
            });
        }
    }

    function handleFavorite(productCardEl) {
        const heartIcon = productCardEl.querySelector(".product-card__header-heart i");

        if (heartIcon.classList.contains("icon-heart-filled")) {
            heartIcon.classList.remove("icon-heart-filled");
        } else {
            heartIcon.classList.add("icon-heart-filled");
        }
    }

    // Делегирование событий
    container.addEventListener("click", (e) => {
        const showMoreBtn = e.target.closest(".product-card__content-buttons-more");
        const favoriteBtn = e.target.closest(".product-card__header-heart");
        const toCartBtn = e.target.closest(".product-card__content-buttons-to-cart");

        if (showMoreBtn) {
            const productCardEl = showMoreBtn.closest(".product-card");
            if (productCardEl) handleShowMore(productCardEl);
        }

        if (favoriteBtn) {
            const productCardEl = favoriteBtn.closest(".product-card");
            //if (productCardEl) handleFavorite(productCardEl);
        }

        if (toCartBtn) {
            const productCardEl = toCartBtn.closest(".product-card");
            if (productCardEl) {
                const counter = new ProductCardCounter(productCardEl);
                counter.open();
            }
        }
    });

    // Инициализация только того, что не требует событий
    const productCards = document.querySelectorAll(".product-card");

    productCards.forEach((productCardEl) => {
        const wrapper = productCardEl.querySelector(".product-card__wrapper");
        const titleEl = productCardEl.querySelector(".product-card__content-heading-title");
        const description = productCardEl.querySelector(".product-card__content-heading-description");
        const collapsedButtonsWrapper = productCardEl.querySelector(".product-card__content-collapsed-buttons-wrapper");

        if (wrapper) {
            const mediaQuery = window.matchMedia("(min-width: 992px)");
            const mediaChange = () => {
                productCardEl.style.minHeight = `${wrapper.scrollHeight}px`;
            };
            mediaQuery.addEventListener("change", mediaChange);
            mediaChange();
        }

        if (titleEl) initProductTitle(titleEl);
        if (description) clamp(description, { clamp: 5 });

        if (collapsedButtonsWrapper) {
            collapsedButtonsWrapper.style.maxHeight = 0;
        }
    });
}